"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformRecord = exports.transform = exports.removeSymbols = exports.getRemoteAddress = exports.getLogSource = void 0;
var _exenv = require("exenv");
var _config = _interopRequireDefault(require("../config"));
var _redactJWT = require("../redactJWT");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('winston'),
  format = _require.format;
var _require2 = require('request-ip'),
  getClientIp = _require2.getClientIp;
var getLogSource = exports.getLogSource = function getLogSource(callStackStr) {
  var _callStackStr$split, _logSource$split, _logSource$match;
  // convert the newline-separated call stack string to an array
  // where each line is a level in call stack, zero is top of call stack
  var callStackArray = (callStackStr === null || callStackStr === void 0 || (_callStackStr$split = callStackStr.split) === null || _callStackStr$split === void 0 ? void 0 : _callStackStr$split.call(callStackStr, '\n')) || [];
  var logSource = '';

  // iterate through the above array and find the
  // first level that has a call source other than NuiLogger.js.
  for (var i = 0; i < callStackArray.length; i += 1) {
    var _currentCallSource$in, _currentCallSource$in2;
    var currentCallSource = callStackArray[i];
    if ((currentCallSource === null || currentCallSource === void 0 || (_currentCallSource$in = currentCallSource.indexOf) === null || _currentCallSource$in === void 0 ? void 0 : _currentCallSource$in.call(currentCallSource, 'at')) !== -1 && (currentCallSource === null || currentCallSource === void 0 || (_currentCallSource$in2 = currentCallSource.indexOf) === null || _currentCallSource$in2 === void 0 ? void 0 : _currentCallSource$in2.call(currentCallSource, 'NuiLogger.js')) === -1) {
      var _currentCallSource$tr;
      // this is the top most caller of NuiLogger
      logSource = (currentCallSource === null || currentCallSource === void 0 || (_currentCallSource$tr = currentCallSource.trim) === null || _currentCallSource$tr === void 0 ? void 0 : _currentCallSource$tr.call(currentCallSource)) || '';
      break;
    }
  }
  // extract function name, file URL and line number from
  // log source which is in the format "at func (file:line:col)"
  // e.g. "at server (nui-fishfood/lib/server.js:42:24)"
  var func = ((_logSource$split = logSource.split(' ')) === null || _logSource$split === void 0 ? void 0 : _logSource$split[1]) || '';
  var fileString = ((_logSource$match = logSource.match(/\(([^)]+)\)/)) === null || _logSource$match === void 0 ? void 0 : _logSource$match[1]) || '';
  var fileMetaArray = fileString.split(':');
  var file = (fileMetaArray === null || fileMetaArray === void 0 ? void 0 : fileMetaArray[0]) || '';
  var line = parseInt(fileMetaArray === null || fileMetaArray === void 0 ? void 0 : fileMetaArray[1], 10) || '';
  return {
    file: file,
    line: line,
    func: func
  };
};
var getClientIpFromReqHeaders = function getClientIpFromReqHeaders(req) {
  var clientIp;
  try {
    clientIp = getClientIp(req);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('NuiLogger.transform.getClientIpFromReqHeaders: Exception in requestIp.getClientIp:', e);
    clientIp = '';
  }
  return clientIp;
};
var getRemoteAddress = exports.getRemoteAddress = function getRemoteAddress(req) {
  var remoteAddress;
  try {
    remoteAddress = req.connection.remoteAddress;
  } catch (error) {
    remoteAddress = getClientIpFromReqHeaders(req);
  }
  if (!remoteAddress) {
    remoteAddress = getClientIpFromReqHeaders(req);
  }
  return remoteAddress;
};
var getRequestFields = function getRequestFields(request) {
  if (!request) {
    return null;
  }
  var method = request.method,
    url = request.url,
    _request$headers = request.headers,
    headersOriginal = _request$headers === void 0 ? {} : _request$headers,
    originalUrl = request.originalUrl,
    _request$session = request.session,
    session = _request$session === void 0 ? {} : _request$session,
    correlationId = request.correlationId,
    requestId = request.requestId,
    _request$app = request.app,
    app = _request$app === void 0 ? {
      locals: {
        baseUrl: ''
      }
    } : _request$app,
    _request$body = request.body,
    body = _request$body === void 0 ? {} : _request$body,
    _request$cookies = request.cookies,
    cookies = _request$cookies === void 0 ? {} : _request$cookies;
  var logSessionData = _config.default.nui.session.use_performance_degrading_session_logging;
  var headers = (0, _redactJWT.redactJWT)(headersOriginal);
  function resolveApplication() {
    if (_config.default.nui.log.application) {
      // Prefer NUI_LOG_APPLICATION over URL parsing if it exists
      return _config.default.nui.log.application;
    }
    return "".concat(app.locals.baseUrl.replace('/', '').replace('/', '-'));
  }
  var fields;
  var client = getRemoteAddress(request);
  if (logSessionData) {
    var getSessionId = function getSessionId(_ref, cookies) {
      var sessionId = _ref.SessionId;
      if (sessionId) {
        return sessionId.toLowerCase();
      }
      var sIdValue = cookies.OTSESSIONAABQRD || cookies.OTSESSIONAABQRN;
      return sIdValue ? sIdValue.replace(/G/g, '-').toLowerCase() : null;
    };
    fields = {
      method: method,
      url: url,
      headers: headers,
      client: client,
      endpoint: originalUrl,
      root: {
        correlation_id: correlationId,
        request_id: requestId,
        session_id: getSessionId(session, cookies),
        application: resolveApplication(),
        user_uuid: session.ConcurId,
        company_uuid: session.CompanyUUID
      },
      cte: _objectSpread({
        user_id: session.UserID,
        company_id: session.CompanyID,
        cuuid: session.CUUID,
        entity_code: session.CESEntityID,
        prod_offering: session.ProdOffering
      }, body.cte),
      travel: {}
    };
  } else {
    fields = {
      method: method,
      url: url,
      headers: headers,
      client: client,
      endpoint: originalUrl,
      root: {
        correlation_id: correlationId,
        request_id: requestId,
        application: resolveApplication()
      },
      cte: _objectSpread({}, body.cte),
      travel: {}
    };
  }
  return fields;
};
var getResponseFields = function getResponseFields(response) {
  if (!response || !response.statusCode) return response;
  return {
    statusCode: response.statusCode,
    header: response._header
  };
};
var removeSymbols = exports.removeSymbols = function removeSymbols(record) {
  return Object.fromEntries(Object.entries(record));
};
var transformRecord = exports.transformRecord = function transformRecord(record) {
  var _record, _record2;
  var requestFields = getRequestFields((_record = record) === null || _record === void 0 ? void 0 : _record.req);
  if (requestFields !== null) {
    record = _objectSpread(_objectSpread({}, record), {}, {
      req: requestFields
    });
  }
  record = _objectSpread(_objectSpread({}, record), {}, {
    res: getResponseFields((_record2 = record) === null || _record2 === void 0 ? void 0 : _record2.res)
  });
  record['@timestamp'] = new Date().toISOString();

  // move record.err.category and record.err.subcategory
  // up to record.category and record.subcategory
  // without collision
  ['category', 'subcategory'].map(function (field) {
    if (record.err && record.err[field] && !record[field]) {
      record[field] = record.err[field];
      delete record.err[field];
    }
  });
  if (record.err && !record.err.cause && record.cause) {
    record.err.cause = record.cause;
    delete record.cause;
  }
  var parseConcurRoute = function parseConcurRoute(record) {
    var concurRoute;
    if (record.req && record.req.headers && 'concur-route' in record.req.headers) {
      concurRoute = record.req.headers['concur-route'];
      delete record.req.headers['concur-route'];
    }
    return concurRoute;
  };
  var concurRoute = parseConcurRoute(record);
  if (concurRoute) {
    record.request_obj = _objectSpread({
      route: concurRoute
    }, record.request_obj);
  }

  // when there's a request object, move its root, cte, and travel buckets to the
  // top-level, preferring existing top-level props over req when name collisions exist
  if (record.req) {
    record = _objectSpread(_objectSpread(_objectSpread({}, record.req.root), record), {}, {
      cte: record.req.cte,
      travel: record.req.travel
    });
    delete record.req.root;
    delete record.req.cte;
    delete record.req.travel;
  }

  // move category and subcategory into the cte bucket, preferring
  // existing cte props over the top-level when name collisions exist
  record.cte = _objectSpread({
    category: record.category,
    subcategory: record.subcategory
  }, record.cte);
  delete record.category;
  delete record.subcategory;

  // copy record.err_message to record.err
  if (!record.err && record.err_message) {
    record.err = record.err_message;
  }
  var someMessage = (record.msg || record.message || '').trim() || record.err;

  // in some cases there is entire err message object there,
  // and we do not want to stick it all into description
  if (someMessage && someMessage.message) {
    someMessage = someMessage.message;
  }
  if (!record.description) {
    // use someMessage as the description
    record.description = someMessage;
  } else {
    // append someMessage as the description
    record.description = "".concat(record.description).concat(someMessage ? "\n\n".concat(someMessage) : '');
  }
  record.application = record.application || record.name;
  record.roletype = record.roletype || _config.default.nui.log.roletype;
  record.type = record.type || 'log';
  record.time = new Date();
  delete record.msg;
  delete record.message;
  delete record.err_message;

  /*
   * Feeds official exception_obj bucket
   * Cf https://wiki.concur.com/confluence/display/LOGS/Data+version+-+2
   */
  if (record.err) {
    var _record3 = record,
      err = _record3.err;
    if (typeof err === 'string') {
      var errorMsg = someMessage;
      // Try to unwrap the message if it is in a json object
      try {
        var jsonMsg = JSON.parse(someMessage);
        if (jsonMsg.Message) {
          errorMsg = jsonMsg.Message;
        }
      } catch (e) {
        // parse error - do nothing.
      }
      record.exception_obj = {
        message: errorMsg
      };
    } else {
      if (!record.description) {
        record.description = err.message;
      }
      var causeObj = err.code || err.cause ? {
        cause: err.code || err.cause
      } : {};
      record.exception_obj = _objectSpread(_objectSpread({
        type: err.name,
        message: err.message
      }, causeObj), {}, {
        stacktrace: err.stack
      });
      record.err = _objectSpread({
        name: err.name,
        message: err.message,
        stack: err.stack
      }, causeObj);
    }
  }
  delete record.cause;
  if (typeof record.description !== 'string') {
    record.description = JSON.stringify(record.description);
  }
  if (!_exenv.canUseDOM && record.callStack) {
    record.src = getLogSource(record.callStack);
  }
  delete record.callStack;
  return record;
};
var transform = exports.transform = format(function (record, _ref2) {
  var validateFn = _ref2.validateFn;
  try {
    var transformedRecord = transformRecord(record);
    if (typeof validateFn === 'function') {
      return validateFn(transformedRecord);
    }
    return transformedRecord;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('NuiLogger.transform: Exception trying to transform the log record:', e);
    return record;
  }
});